import { createContext, useContext } from "react"

import { FirestoreError } from "firebase/firestore"

import { User } from "../authentication-context"

export type UsersContextProps = {
    data: User[]
    loading: boolean
    error?: FirestoreError
    update: () => void
}

export const UsersContext = createContext<UsersContextProps>({
    data: [],
    loading: true,
    error: undefined,
    update: () => null,
})

export const useUsers = () => useContext(UsersContext)

export * from "./UsersProvider"
